import Login from "./modules/login/Login.vue"
import Auth from "./modules/login/Auth.vue"
import DashView from "./Dash.vue"
import Apps from "./Apps.vue"

import Dashboard from "./modules/dashboard/Dashboard.vue"
import SearchRegistration from "./modules/registration/SearchRegistration.vue"
import ListRegistration from "./modules/registration/ListRegistration.vue"
import ListRegistrationOutstanding from "./modules/registration/ListRegistrationOutstanding.vue"

import UploadMaterial from "./modules/registration/UploadMaterial.vue"

import AllRegistration from "./modules/registration/AllRegistration.vue"
import Registration from "./modules/registration/AddRegistration.vue"
import ListCatalog from "./modules/catalog/ListCatalog.vue"
import ListCatalogProcess from "./modules/catalog/ListCatalogProcess.vue"
import ListCatalogOutstanding from "./modules/catalog/ListCatalogOutstanding.vue"
import CatalogUploadMaterial from "./modules/catalog/CatalogUploadMaterial.vue"
import ListApprove from "./modules/approve/ListApprove.vue"
import CatalogRegistration from "./modules/catalog/CatalogRegistration.vue"
import ListProcurement from "./modules/procurement/ListProcurement.vue"

//Master Data
import Company from "./modules/master/company/company.vue"
import Plant from "./modules/master/plant/plant.vue"

import Uom from "./modules/master/uom/uom.vue"
import MaterialType from "./modules/master/material_type/material_type.vue"
import MaterialGroup from "./modules/master/material_group/material_group.vue"
import ExternalGroup from "./modules/master/external_group/external_group.vue"

import ValuationClass from "./modules/master/valuation_class/valuation_class.vue"
import PriceControl from "./modules/master/price_control/price_control.vue"
import LabOffice from "./modules/master/lab_office/lab_office.vue"

//Material
import InitialItem from "./modules/master/initial_item/initial_item.vue"
import Inc from "./modules/master/inc/inc.vue"
import IncAttribute from "./modules/master/inc_attribute/inc_attribute.vue"

//User
import User from "./modules/master/user/user.vue"
import Role from "./modules/master/role/role.vue"
import Departement from "./modules/master/departement/departement.vue"

//Dashboard
import ApproveRatio from "./modules/dashboard/approve_ratio.vue"
import RequestRatio from "./modules/dashboard/request_ratio.vue"
import AverageSLA from "./modules/dashboard/average_sla.vue"
import TopRequester from "./modules/dashboard/top_requester.vue"
import TopApprover from "./modules/dashboard/top_approver.vue"
import TopComplain from "./modules/dashboard/top_complain.vue"
import AverageSLAUser from "./modules/dashboard/average_sla_user.vue"
import LogFeedback from "./modules/dashboard/log_feedback.vue"

// Master Data
import PurchasingGroup from "./modules/master/mrp/purchasing_group.vue"
import MrpControl from "./modules/master/mrp/mrp_control.vue"
import MrpGroup from "./modules/master/mrp/mrp_group.vue"
import MrpProfile from "./modules/master/mrp/mrp_profile.vue"
import MrpType from "./modules/master/mrp/mrp_type.vue"
import AvailibilityCheck from "./modules/master/mrp/availibility_check.vue"
import BaseUnit from "./modules/master/mrp/base_unit.vue"
import ValuationCategory from "./modules/master/mrp/valuation_category.vue"
import ProcurementType from "./modules/master/mrp/procurement_type.vue"
import SpecialProc from "./modules/master/mrp/special_proc.vue"
import IndustrySector from "./modules/master/mrp/industry_sector.vue"
import LotSizeProcedure from "./modules/master/mrp/lot_size_procedure.vue"
import Manufacturer from "./modules/master/mrp/manufacturer.vue"
import PurchasingValue from "./modules/master/mrp/purchasing_value.vue"
import BasicMaterial from "./modules/master/mrp/basic_material.vue"
import ValuationType from "./modules/master/mrp/valuation_type.vue"
import StorageLocation from "./modules/master/mrp/storage_location.vue"

//Log
//import LogActivity from './modules/master/log_activity/log_activity.vue';
//import LogService from './modules/master/log_service/log_service.vue';
//import Departement from './modules/master/departement/departement.vue';

import ServiceInitial from "./modules/catalog/ServiceInitial.vue"

const routes = [
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/auth",
    component: Auth,
  },
  {
    path: "/Apps/:token",
    component: Apps,
  },
  {
    path: "/",
    component: DashView,
    children: [
      {
        path: "dashboard",
        alias: "",
        component: Dashboard,
        name: "Dashboard",
      },
      {
        path: "searchRegister",
        alias: "",
        component: SearchRegistration,
        name: "SearchRegister",
      },
      {
        path: "listRegister/:status?",
        alias: "",
        component: ListRegistration,
        name: "ListRegister",
      },
      {
        path: "listRegisterOutstanding",
        alias: "",
        component: ListRegistrationOutstanding,
        name: "ListRegisterOutstanding",
      },
      {
        path: "uploadMaterial",
        alias: "",
        component: UploadMaterial,
        name: "UploadMaterial",
      },
      {
        path: "allRegister/",
        alias: "",
        component: AllRegistration,
        name: "AllRegister",
      },
      {
        path: "addRegister/:server?/:type?/:id?",
        alias: "",
        component: Registration,
        name: "AddRegister",
      },
      {
        path: "listCatalog",
        alias: "",
        component: ListCatalog,
        name: "ListCatalog",
      },
      {
        path: "listCatalogProcess",
        alias: "",
        component: ListCatalogProcess,
        name: "listCatalogProcess",
      },
      {
        path: "listCatalogOutstanding",
        alias: "",
        component: ListCatalogOutstanding,
        name: "listCatalogOutstanding",
      },
      {
        path: "listCatalogUploadMaterial",
        alias: "",
        component: CatalogUploadMaterial,
        name: "CatalogUploadMaterial",
      },
      {
        path: "catalogRegister/:type?/:id?",
        alias: "",
        component: CatalogRegistration,
        name: "catalogRegister",
      },
      {
        path: "serviceInitial/",
        alias: "",
        component: ServiceInitial,
        name: "serviceInitial",
      },
      {
        path: "listApprove",
        alias: "",
        component: ListApprove,
        name: "ListApprove",
      },
      {
        path: "listApprove",
        alias: "",
        component: ListApprove,
        name: "ListApprove",
      },
      {
        path: "listProcurement",
        alias: "",
        component: ListProcurement,
        name: "ListProcurement",
      },
      {
        path: "company",
        alias: "",
        component: Company,
        name: "company",
      },
      {
        path: "plant",
        alias: "",
        component: Plant,
        name: "plant",
      },
      {
        path: "uom",
        alias: "",
        component: Uom,
        name: "uom",
      },
      {
        path: "materialType",
        alias: "",
        component: MaterialType,
        name: "materialType",
      },
      {
        path: "materialGroup",
        alias: "",
        component: MaterialGroup,
        name: "materialGroup",
      },
      {
        path: "externalGroup",
        alias: "",
        component: ExternalGroup,
        name: "externalGroup",
      },
      {
        path: "valuationClass",
        alias: "",
        component: ValuationClass,
        name: "valuationClass",
      },
      {
        path: "priceControl",
        alias: "",
        component: PriceControl,
        name: "priceControl",
      },
      {
        path: "labOffice",
        alias: "",
        component: LabOffice,
        name: "labOffice",
      },
      {
        path: "initialItem",
        alias: "",
        component: InitialItem,
        name: "initialItem",
      },
      {
        path: "inc",
        alias: "",
        component: Inc,
        name: "inc",
      },
      {
        path: "incAttribute",
        alias: "",
        component: IncAttribute,
        name: "incAttribute",
      },
      {
        path: "departement",
        alias: "",
        component: Departement,
        name: "departement",
      },
      {
        path: "role",
        alias: "",
        component: Role,
        name: "role",
      },
      {
        path: "user",
        alias: "",
        component: User,
        name: "user",
      },
      {
        path: "approveRatio",
        alias: "",
        component: ApproveRatio,
        name: "approveRatio",
      },
      {
        path: "requestRatio",
        alias: "",
        component: RequestRatio,
        name: "requestRatio",
      },
      {
        path: "averageSLA",
        alias: "",
        component: AverageSLA,
        name: "averageSLA",
      },
      {
        path: "averageSLAUser",
        alias: "",
        component: AverageSLAUser,
        name: "averageSLAUser",
      },
      {
        path: "topRequester",
        alias: "",
        component: TopRequester,
        name: "topRequester",
      },
      {
        path: "topApprover",
        alias: "",
        component: TopApprover,
        name: "topApprover",
      },
      {
        path: "topComplain",
        alias: "",
        component: TopComplain,
        name: "topComplain",
      },
      {
        path: "purchasing-group",
        alias: "",
        component: PurchasingGroup,
        name: "purchasingGroup",
      },
      {
        path: "mrp-control",
        alias: "",
        component: MrpControl,
        name: "mrpControl",
      },
      {
        path: "mrp-group",
        alias: "",
        component: MrpGroup,
        name: "mrpGroup",
      },
      {
        path: "mrp-profile",
        alias: "",
        component: MrpProfile,
        name: "mrpProfile",
      },
      {
        path: "mrp-type",
        alias: "",
        component: MrpType,
        name: "mrpType",
      },
      {
        path: "availibility-check",
        alias: "",
        component: AvailibilityCheck,
        name: "AvailibilityCheck",
      },
      {
        path: "base-unit",
        alias: "",
        component: BaseUnit,
        name: "BaseUnit",
      },
      {
        path: "valuation-category",
        alias: "",
        component: ValuationCategory,
        name: "ValuationCategory",
      },
      {
        path: "procurement-type",
        alias: "",
        component: ProcurementType,
        name: "ProcurementType",
      },
      {
        path: "special-proc",
        alias: "",
        component: SpecialProc,
        name: "SpecialProc",
      },
      {
        path: "industry-sector",
        alias: "",
        component: IndustrySector,
        name: "IndustrySector",
      },
      {
        path: "lot-size-procedure",
        alias: "",
        component: LotSizeProcedure,
        name: "LotSizeProcedure",
      },
      {
        path: "manufacturer",
        alias: "",
        component: Manufacturer,
        name: "Manufacturer",
      },
      {
        path: "purchasing-value",
        alias: "",
        component: PurchasingValue,
        name: "PurchasingValue",
      },
      {
        path: "basic-material",
        alias: "",
        component: BasicMaterial,
        name: "BasicMaterial",
      },
      {
        path: "valuation-type",
        alias: "",
        component: ValuationType,
        name: "ValuationType",
      },
      {
        path: "storage-location",
        alias: "",
        component: StorageLocation,
        name: "StorageLocation",
      },
      {
        path: "logFeedback",
        alias: "",
        component: LogFeedback,
        name: "logFeedback",
      },
    ],
  },
]

export default routes
